import { useEffect } from "react";
import { Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_backend_helper";
import { setAuthorization as setAuthAuthorization } from "../helpers/api_auth_helper"
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

import { getSigninUrl } from "../casdoorSdk";

const AuthProtected = (props) => {
  const authData = createSelector(
    (state) => state.Token,
    (token) => token.token
  );
  const token = useSelector(authData);
  useEffect(() => {
    if (!token) {
      window.location.href = getSigninUrl();
      return (
        // <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
        <div>
          <p>Redirigiendo a la página de inicio de sesión externa...</p>
        </div>
      );
    } else {
      setAuthorization(token);
      setAuthAuthorization(token);
    }

  }, [token]);

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };